import baseFontSize from './baseFontSize'
import { FontScales } from './types'

export function fontScale(scale: FontScales) {
    return Math.ceil(baseFontSize * scale)
}

export default fontScale
